<template>
<div id="fuel_drop_view">
  <div :class="`loader${loaderClass}`" v-show="loading"></div>
  <div id="page-content-wrapper" class="admin-content-area">
    <template v-if="cantAccessPage === true">
      <div class="page-name">
        <div class="page-title"> Fuel Drops Details </div>
        <div class="btn-groups text-right">
          <router-link class="btn btn-secondary" v-bind:to="{name: 'FuelDropList'}"> <i class="fp-back"></i> Back</router-link>
        </div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content customer-credit-detail list-view">
          <section class="internal-container">
            <div id="tabs" class="containerTab mt-3">
              <div class="tabs">
                <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Fuel Drop Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
              </div>
              <div class="content">
               <div v-show="activetab === 1" class="tabcontent">
                <div class="form-row no-divider">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col">Product:</label>
                      <span class="col">
                          {{titleCase(fuelDropData.company_name)}}
                            <template v-if="fuelDropData.loc_code">
                            ( {{titleCase(fuelDropData.loc_code)}} )
                            </template>
                            <template v-if="fuelDropData.item_name">
                            | {{titleCase(fuelDropData.item_name)}}
                            </template>
                            <template v-if="fuelDropData.tank_no">
                              | {{titleCase(fuelDropData.tank_no)}}
                            </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Date Time:</label>
                      <span class="col">{{titleCase(fuelDropData.date_time)}}</span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Quantity:</label>
                      <span class="col">{{fuelDropData.quantity}}</span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Vendor:</label>
                      <span class="col">
                                  <template v-if="fuelDropData.vendor_code">
                                    {{titleCase(fuelDropData.vendor_code)}}
                                  </template>
                                  <template v-if="fuelDropData.vendor_name">
                                   | {{titleCase(fuelDropData.vendor_name)}}
                                  </template>
                                  <template v-else>
                                        -
                                  </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Vendor Invoice:</label>
                      <span class="col">
                                  <template v-if="fuelDropData.bill_id">
                                    {{titleCase(fuelDropData.voucher_number)}}
                                  </template>
                                  <template v-else>
                                        -
                                  </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Received:</label>
                      <span class="col">
                                  <template v-if="fuelDropData.status != 'open'">
                                            Yes
                                  </template>
                                  <template v-else>
                                        No
                                    </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">UOM:</label>
                      <span class="col">
                                  <template v-if="fuelDropData.uom_id">
                                            {{titleCase(fuelDropData.measurement_unit + " ( " + fuelDropData.symbol + " )")}}
                                  </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">User:</label>
                      <span class="col">
                                  <template v-if="fuelDropData.uFirstName">
                                    {{titleCase(fuelDropData.uFirstName)}}
                                  </template>
                                  <template v-if="fuelDropData.uLastName">
                                    {{titleCase(fuelDropData.uLastName)}}
                                  </template>
                      </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Status</label>
                      <span class="col">{{titleCase(fuelDropData.status)}}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col">Actual Price:</label>
                      <span class="col">${{amountFormat(fuelDropData.actual_price,4)}} </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Estimated Cost (Per Gallon):</label>
                      <span class="col">${{amountFormat(fuelDropData.cost,4)}} </span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Federal Diesel Excess Tax:</label>
                      <span class="col">{{fuelDropData.federal_diesel_excise_tax}}</span>
                    </div>
                    <div class="row form-group">
                      <label class="col">Federal L.U.S.T. Tax:</label>
                      <span class="col">{{fuelDropData.federal_lust_tax}}</span>
                    </div>
                    <div class="row form-group">
                      <label class="col">DSL-Fed Enviromental Fee:</label>
                      <span class="col">{{fuelDropData.dsl_fed_enviromental_fee}}</span>
                    </div>
                    <div class="row form-group">
                      <label class="col">CA AB32 ENV Surcharge:</label>
                      <span class="col">{{fuelDropData.ca_ab32_env_surcharge}}</span>
                  </div>
                </div>
                </div>
               </div>
               <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                    <fuel-drop-activity-log-list :activityLogVal="activityLogsTabValue"></fuel-drop-activity-log-list>
                </div>
              </div>
            </div>
          </section>
          <!-- Gl Entry -->
          <section class="internal-container border-top-table-fl mt-4 loader-position" v-if="canViewGL">
            <div :class="`loader-div${loaderClass}`" v-show="loadingGL"></div>
            <div class="journal-title">
                <h5> {{glTitle}} <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
            </div>
            <div :id="'demo'" class="accordian-body collapse show">
                <div class="table-reponsive-sm">
                    <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                        <thead>
                            <tr class="table-primary">
                                <th>Account</th>
                                <th class="text-right">Debit</th>
                                <th class="text-right">Credit</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody v-if="journalsArr != undefined && journalsArr.length > 0">
                            <template v-for="(journalItem , journalKey) in journalsArr">
                                <tr :key="'journal'+journalKey">
                                    <template v-if="journalItem.account_description == 'Total'">
                                        <td class="text-right">{{journalItem.account_description}}</td>
                                    </template>
                                    <template v-else>
                                        <td>{{journalItem.account_description}}</td>
                                    </template>
                                    <td class="text-right">{{journalItem.debit}}</td>
                                    <td class="text-right">{{journalItem.credit}}</td>
                                    <td class="text-right">{{journalItem.journal_amount}}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4"><h5>No GL Found</h5></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
         <!-- Gl Entry -->
        </div>
      </div>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
    </template>
    <template v-else>
        <loading-content></loading-content>
    </template>
    <app-footer></app-footer>
  </div>
</div>
</template>
<script>
import Vue from "vue";

import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("fuel-drop-activity-log-list", ActivityLogListView);

import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "FuelDropView",
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    firstLoad: 0,
    cantAccessPage: "",
    loading:false,
    fuelDropData:[],
    activetab: 1,
    activityLogsTabValue: "dontLoadList",
    activityLoaded:false,
    glTitle:"General Ledger",
    woGlTitle:"Work Order GL Preview",
    workOrderGLArr:[],
    canViewGL:false,
    journalsArr:[],
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;

            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_drop') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'view_general_ledger') {
                        self.canViewGL = true;
                    }
                }
            }

        }
  },
  mounted: function() {
      var self = this;
      self.getPermissions();
      self.loadFuelDrop();
  },

  metaInfo() {
      return{
          title: "Fuel Drop View | " +process.env.COPYRIGHT_NAME
      }
  },
  methods: {
    loadFuelDrop(){
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/fuel-drop/" + segments[3],
          type: "GET",
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
              self.loading = false;
              if (data.status == "success") {
                  self.fuelDropData=data.content;
              }
              self.loadFuelDropGL();
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,false,'fuel-drop-by-id')
          }
      });
    },
    // Load Fuel Drop GL Entry
    loadFuelDropGL() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var fields = {
            name:"fuel_drop",
            id:segments[3],
        };
        self.loadingGL = true;
        $.ajax({
            url:process.env.ROOT_API + "/module/gl",
            type:"POST",
            data:fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loadingGL = false;
                if (data.status == "success"){
                    self.journalsArr = data.content;          
                }
            },
            error: function (jqXHR, exception) {
                self.loadingGL = false;
                self.generateStatusCodeMessage(jqXHR,true,'bill-gl')
            }
        });
    },
    activityLogs(){

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      self.$root.$emit('activity_log_opted','fuel drop',segments[3]);
      self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      self.activetab = 2;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FuelDropView.vue